import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
var useStyles = makeStyles({
    container: function (props) { return ({
        width: props.width,
        marginBottom: 32
    }); }
});
export var StepSelectorGroup = function (props) {
    var styles = useStyles(props);
    return React.createElement("div", { className: styles.container }, props.children);
};
